import { Component, EventEmitter, Input, Output } from '@angular/core';

const MUNDIPAGG_ERRORS = {
  'You may not use numbers or special characters.': 'Você não pode usar números ou caracteres especiais no nome do titular do cartão.',
  'The number field is not a valid card number': 'Este não é um número de cartão válido.',
  'Could not detect card brand.': 'A bandeira do cartão não é aceita no momento, para mais informaçãoes entre em contato com o suporte.',
};

@Component({
  selector: 'ng-tickets-error',
  styleUrls: ['./error.component.scss', '../../tickets/styles/ticket.scss'],
  template: `
    <section class="error-container">

      <div class="cross"></div>

      <h2 class="error-title">{{ errorTitle }}</h2>

      <p *ngIf="!validationErrors?.length">{{ errorMessage }}</p>

      <ul *ngIf="validationErrors?.length">
        <li *ngFor="let error of validationErrors">{{mundipaggErrors[error] ? mundipaggErrors[error] : error}}</li>
      </ul>

      <div class="container-button" *ngIf="backButton">
        <button class="btn" (click)="backButtonEvent.emit()">Tentar novamente</button>
      </div>
    </section>
  `
})
export class ErrorComponent {

  @Input() errorTitle = 'Pagamento não autorizado';
  @Input() errorMessage = 'Ocorreu um erro ao processar o pagamento. Por favor, verifique os seus dados e tente novamente.';
  @Input() backButton = false;
  @Input() validationErrors = [];
  @Output() backButtonEvent = new EventEmitter();

  mundipaggErrors = MUNDIPAGG_ERRORS;

}
